export default __webpack_public_path__ + "static/cloudator-brochure-3d-ipad-0e4561927a1e693f0f9bbfa66be69b91.jpg";